<template>
    <fade-inwards-animation
        :elements="[
            {
                element: () => $refs.section,
            },
            {
                element: () => $refs.left,
                direction: 'right',
            },
            {
                element: () => $refs.right,
                direction: 'left',
            },
        ]"
    >
        <component :is="tag" class="patterned-container" ref="section">
            <div class="patterned-section">
                <div class="left" ref="left">
                    <div class="pattern-container">
                        <lazy-background
                            class="pattern"
                            src="../../../assets/images/svgs/itsu-pattern-vertical.svg"
                            :alt="$snippet('itsu_pattern', 'Itsu pattern')"
                            v-test:leftPattern
                        />
                    </div>
                </div>
                <b-container>
                    <mobile-gutter>
                        <div class="content">
                            <slot />
                        </div>
                    </mobile-gutter>
                </b-container>
                <div class="right" ref="right">
                    <div class="pattern-container">
                        <lazy-background
                            class="pattern"
                            src="../../../assets/images/svgs/itsu-pattern-vertical.svg"
                            :alt="$snippet('itsu_pattern', 'Itsu pattern')"
                            v-test:rightPattern
                        />
                    </div>
                </div>
            </div>
        </component>
    </fade-inwards-animation>
</template>

<script>
    export default {
        name: 'patterned-container',

        props: {
            tag: {
                type: String,
                default: 'div',
            },
        },
    };
</script>

<style lang="scss" scoped>
    .patterned-section {
        display: flex;
    }

    .left, .right {
        flex-grow: 1;
        position: relative;
    }

    .right {
        .pattern-container {
            left: -25px;

            @include media-breakpoint-up(md) {
                left: -50px;
            }
        }

        .pattern.pattern {
            right: 0;
        }
    }

    .left {
        .pattern-container {
            right: -25px;

            @include media-breakpoint-up(md) {
                right: -50px;
            }
        }

        .pattern.pattern {
            left: 0;
            transform: rotate(180deg);
            background-position: bottom left;
        }
    }

    .pattern-container {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
    }

    .pattern.pattern {
        background-size: 90px 125px;
        background-repeat: repeat-y;
        background-position: top left;
        width: 90px;
        position: absolute;
        top: 0;
        bottom: 0;
        max-width: 100%;

        @include media-breakpoint-up(md) {
            width: 115px;
            background-size: 180px 250px;
        }
    }

    .content {
        padding: 0 25px;

        @include media-breakpoint-up(md) {
            padding: 0 75px;
        }
    }
</style>
